import * as posModels from "./posModels";
import instance from "./instance";
import {logs as urls} from "./urls";

export function logGeneralAction(
    action: string,
    stationMode: posModels.StationMode,
): Promise<void> {
    return instance
        .request({
            url: urls.general,
            method: "POST",
            data: {
                action,
                stationMode,
                timestamp: new Date().toISOString(),
            },
        })
        .then((response) => response.data);
}

export function logManagerAction(
    action: string,
    managerId: string,
    stationMode: posModels.StationMode,
): Promise<void> {
    return instance
        .request({
            url: urls.manager,
            method: "POST",
            data: {
                action,
                managerId,
                stationMode,
                timestamp: new Date().toISOString(),
            },
        })
        .then((response) => response.data);
}
